const getImageMaxDimensions = (image, maxHeight, maxWidth) => {
  const { height, width } = image.dimensions;
  const aspectRatio = width / height;
  let newHeight = height;
  let newWidth = width;
  if (newHeight > maxHeight) {
    newHeight = maxHeight;
    newWidth = newHeight * aspectRatio;
  }
  if (newWidth > maxWidth) {
    newWidth = maxWidth;
    newHeight = newWidth / aspectRatio;
  }
  return {
    height: newHeight,
    width: newWidth
  };
};
const isMarkdownText = (item) => {
  return item.markdown_text !== void 0;
};
const removeQueryParams = (url, paramsToRemove) => {
  const parsedUrl = new URL(url);
  paramsToRemove.forEach((param) => {
    parsedUrl.searchParams.delete(param);
  });
  return parsedUrl.toString();
};
const fetchSvg = async (url) => {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error("Failed to fetch SVG");
    }
    const data = await response.text();
    return data;
  } catch (error) {
    console.error("Error fetching SVG:", error);
    return "";
  }
};
const updateSvgContent = (svg, color) => {
  const parser = new DOMParser();
  const xmlDoc = parser.parseFromString(svg, "image/svg+xml");
  const parserError = xmlDoc.getElementsByTagName("parsererror");
  if (parserError.length > 0) {
    console.error("Error parsing SVG:", parserError[0].textContent);
    return "";
  }
  const pathElements = xmlDoc.querySelectorAll(
    "path, circle, rect, polyline, polygon"
  );
  pathElements.forEach((el) => {
    if (!el.getAttribute("fill") || el.getAttribute("fill") === "none") {
      el.setAttribute("fill", color);
    }
  });
  xmlDoc.documentElement.setAttribute("width", "100%");
  xmlDoc.documentElement.setAttribute("height", "100%");
  const serializer = new XMLSerializer();
  return serializer.serializeToString(xmlDoc.documentElement);
};
export {
  fetchSvg,
  getImageMaxDimensions,
  isMarkdownText,
  removeQueryParams,
  updateSvgContent
};
